import type { ObserverInvestigationInfo } from "../../../api/observerTypes";
import { pageRoutes } from "../../../routes";

export const productionInvestigatorSlug = "production-investigator";

export interface InvestigationState {
  ownSessionId?: string;
  startedByOthers?: string;
}

const describeUser = (investigation: ObserverInvestigationInfo) => investigation.userName ?? investigation.userEmail;

export const resolveInvestigationState = (
  investigations: ObserverInvestigationInfo[],
  currentUserId: string
): InvestigationState => {
  // Matched on user id alone like the backend does; an email fallback would let a recreated account claim it.
  const own = investigations.find((investigation) => investigation.userId === currentUserId);
  if (own) {
    return { ownSessionId: own.sessionId };
  }

  const others = investigations.map(describeUser);
  return others.length > 0 ? { startedByOthers: others.join(", ") } : {};
};

export const getInvestigationTooltip = ({ ownSessionId, startedByOthers }: InvestigationState): string => {
  if (ownSessionId) {
    return "Open your investigation";
  }
  if (startedByOthers) {
    return `Investigation started by ${startedByOthers} — click to start your own`;
  }
  return "Investigate with the Production Investigator";
};

export const getInvestigatorUrl = (state: InvestigationState, issueId: string): string => {
  const params = new URLSearchParams({ action: productionInvestigatorSlug });
  if (state.ownSessionId) {
    params.set("sessionId", state.ownSessionId);
  } else {
    params.set("investigateIssueId", issueId);
  }
  return `/${pageRoutes.agents}?${params.toString()}`;
};

// Never deep-links straight to an existing session the way Investigate does: the issue has to be filed
// server-side first, so this always goes through the endpoint.
export const getFileBugUrl = (issueId: string): string => {
  const params = new URLSearchParams({ action: productionInvestigatorSlug, fileBugIssueId: issueId });
  return `/${pageRoutes.agents}?${params.toString()}`;
};
